import React from "react";
import LandingSimpleSection from "@insightfulscience/atomic-react/LandingElement/SimpleSection";
import { Col, Row } from "@insightfulscience/atomic-react/Grid";
import Paragraph from "@insightfulscience/atomic-react/Paragraph";
import NextLink from "@insightfulscience/smart-react/NextLink";
import { ROUTE_CONTACT_US } from "../../routes";

const SectionContact = () => (
	<LandingSimpleSection isBorderNone spacing={{ pt: 10, pb: 24 }}>
		<LandingSimpleSection.Body>
			<Row utility={{ justify: "center" }}>
				<Col lg={10}>
					<Paragraph sx={{ textAlign: "center" }}>
						If you have suggestions for additional plasmids or plasmid
						collections, please{" "}
						<NextLink href={ROUTE_CONTACT_US}>contact us</NextLink>.
					</Paragraph>
				</Col>
			</Row>
		</LandingSimpleSection.Body>
	</LandingSimpleSection>
);

export default SectionContact;
